<template>
	<div>
		<div class="text-center text-primary my-2" v-show="carregandoBuscarCat">
        	<b-spinner class="align-middle"></b-spinner>
        </div>
		<div v-show="!carregandoBuscarCat && deuErroBuscarCat">
			<h3>Não foi possível buscar os dados do CAT nesse momento. Por favor tente novamente mais tarde.</h3>
		</div>
		<div v-show="!carregandoBuscarCat && !deuErroBuscarCat">
			<b-form @submit.prevent="false" class="w-100 p-3 d-flex flex-column justify-content-start gap-sm">
            <h2 class="border-bottom pb-3">FORMULÁRIO CAT</h2>
            <div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Dados da Empresa</h4>
                <b-form-row>
                    <b-col md="8" sm="12" class="d-flex flex-column">
                        <label for="razaoSocial">Razão Social:</label>
                        <b-input placeholder="Razão Social" id="razaoSocial" :disabled="podeDesabilitarInput" v-model="dadosEmpresa.razaoSocial"/>
                    </b-col>
                    <b-col md="4" sm="12" class="d-flex flex-column">
                        <label for="cnpj">CNPJ:</label>
                        <b-input id="cnpj" v-model="dadosEmpresa.cnpj" :disabled="podeDesabilitarInput" placeholder="Ex: 00.000.000/0000-00" v-mask="'##.###.###/####-##'"/>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="8" sm="12" class="d-flex flex-column">
                        <label for="nomeFantasia">Nome Fantasia:</label>
                        <b-input placeholder="Nome Fantasia" id="nomeFantasia" :disabled="podeDesabilitarInput" v-model="dadosEmpresa.nomeFantasia"/>
                    </b-col>
                    <b-col md="2" sm="12" class="d-flex flex-column">
                        <label for="cidade">Cidade:</label>
                        <autoCompleteCidade  ref="autoCompleteCidadeEmpresa" :disabled="podeDesabilitarInput" :value="dadosEmpresa.cidade" @cidadeSelecionada="selecionaCidadeEmpresa($event)"/>
                    </b-col>
                    <b-col md="2" sm="12" class="d-flex flex-column">
                        <label for="estado">Estado:</label>
                        <selectEstados ref="selectEstadoEmpresa" :disabled="podeDesabilitarInput" :value="dadosEmpresa.estado" @estadoSelecionado="selecionaEstadoEmpresa($event)"/>
                    </b-col>
                </b-form-row>
            </div>
            <div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Dados do Funcionário</h4>
                <b-form-row>
                    <b-col md="8" sm="12" class="d-flex flex-column">
                        <label for="funcionario">Funcionário:</label>
                        <b-input placeholder="Funcionário" id="funcionario" :disabled="podeDesabilitarInput" v-model="dadosFuncionario.funcionario"/>
                    </b-col>
                    <b-col md="4" sm="12" class="d-flex flex-column">
                        <label for="cpf">CPF:</label>
                        <b-input id="cpf" v-model="dadosFuncionario.cpf" :disabled="podeDesabilitarInput" placeholder="Ex: 000.000.000-00" v-mask="'###.###.###-##'"/>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col md="6" sm="12" class="d-flex flex-column">
                        <label for="cargo">Cargo:</label>
                        <b-input placeholder="Cargo" id="cargo" :disabled="podeDesabilitarInput" v-model="dadosFuncionario.cargo"/>
                    </b-col>
                    <b-col md="2" sm="12" class="d-flex flex-column">
                        <label for="cbo">CBO:</label>
                        <b-input id="cbo" v-model="dadosFuncionario.cbo" :disabled="podeDesabilitarInput" placeholder="Ex: 00.00-00" v-mask="'##.##-##'"/>
                    </b-col>
                    <b-col md="2" sm="12" class="d-flex flex-column">
                        <label for="estadoCivil">Estado Civil:</label>
						<b-form-select v-model="dadosFuncionario.estadoCivil" id="estadoCivil" :disabled="podeDesabilitarInput">
						      <b-form-select-option value selected disabled>Selecione</b-form-select-option>
						      <b-form-select-option value="Solteiro">Solteiro</b-form-select-option>
							  <b-form-select-option value="Separado">Separado</b-form-select-option>
							  <b-form-select-option value="Divorciado">Divorciado</b-form-select-option>
							  <b-form-select-option value="Casado">Casado</b-form-select-option>
							  <b-form-select-option value="Viúvo">Viúvo</b-form-select-option>
    					</b-form-select>
                    </b-col>
                    <b-col md="2" sm="12" class="d-flex flex-column">
                        <label for="dataAdmissao">Data de Admissão:</label>
						<b-form-datepicker :disabled="podeDesabilitarInput" id="dataAdmissao" v-model="dadosFuncionario.dataAdmissao" locale="pt-br" label-no-date-selected="Selecione..." label-selected="Data Selecionada" label-help :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                    </b-col>
                </b-form-row>
				<b-form-row>
					<b-col md="3" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="acidentesAnteriores">Acidentes Anteriores:</label>
						<b-input id="acidentesAnteriores" :disabled="podeDesabilitarInput" type="number" min="0" class="w-25" v-model="dadosFuncionario.qtdAcidentesAnteriores"/>
					</b-col>
					<b-col md="5" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="tomaRemedioControlado">Toma Remédio Controlado ?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosFuncionario.remedioControlado" name="tomaRemedioControlado" :value="false" @input="limpaCampoNomeRemedio()">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosFuncionario.remedioControlado" name="tomaRemedioControlado" :value="true">Sim</b-form-radio>
						</div>
					</b-col>
					<b-col md="4" sm="12">
						<label for="nomeRemedio">Qual ?</label>
						<b-input id="nomeRemedio" placeholder="Nome do Remédio" :disabled="!dadosFuncionario.remedioControlado || podeDesabilitarInput" v-model="dadosFuncionario.remedio"/>
					</b-col>
				</b-form-row>
            </div>
            <div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Dados do Acidente</h4>
				<b-form-row>
					<b-col md="12" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="houveMorte">Houve Morte ?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.houveMorte" name="houveMorte" :value="false">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.houveMorte" name="houveMorte" :value="true">Sim</b-form-radio>
						</div>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="houveAfastamento">Houve Afastamento?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.houveAfastamento" name="houveAfastamento" :value="false" @input="limpaCampoQtdDiasAfastamento()">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.houveAfastamento" name="houveAfastamento" :value="true">Sim</b-form-radio>
						</div>
						<div class="d-flex align-items-end gap-sm">
							<b-input class="w-25" id="qtdDiasAfastamento" type="number" min="0" :disabled="!dadosAcidente.houveAfastamento || podeDesabilitarInput" v-model="dadosAcidente.qtdDiasAfastamento"/>
							<label for="qtdDiasAfastamento">Dias</label>
						</div>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12" class="d-flex gap-sm">
						<label for="tipoAcidente">Tipo de Acidente:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.tipoAcidente" name="tipoAcidente" value="Típico">Típico</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.tipoAcidente" name="tipoAcidente" value="Trajeto">Trajeto</b-form-radio>
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAcidente.tipoAcidente" name="tipoAcidente" value="Doença Ocupacional">Doença Ocupacional</b-form-radio>
						</div>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="4" sm="12">
						<label for="lesao">Lesão:</label>
						<b-input id="lesao" :disabled="podeDesabilitarInput" v-model="dadosAcidente.lesao" placeholder="Lesão"/>
					</b-col>
					<b-col md="4" sm="12">
						<label for="parteAtingida">Parte Atingida:</label>
						<b-input id="parteAtingida" :disabled="podeDesabilitarInput" v-model="dadosAcidente.parteAtingida" placeholder="Parte Atingida"/>
					</b-col>
					<b-col md="4" sm="12">
						<label for="ladoAtingido">Lado Atingido:</label>
						<b-form-select v-model="dadosAcidente.ladoAtingido" id="ladoAtingido" :disabled="podeDesabilitarInput">
						      <b-form-select-option value selected disabled>Selecione</b-form-select-option>
						      <b-form-select-option value="Direita">Direita</b-form-select-option>
							  <b-form-select-option value="Esquerda">Esquerda</b-form-select-option>
    					</b-form-select>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="6" sm="12">
						<label for="causa">Causa:</label>
						<b-input id="causa" v-model="dadosAcidente.causa" placeholder="Causa" :disabled="podeDesabilitarInput"/>
					</b-col>
				</b-form-row>
				<b-form-row>
                	<b-col sm="12" md="2" class="d-flex flex-column justify-content-between">
                    	<label for="data">Data:</label>
                    	<b-form-datepicker :disabled="podeDesabilitarInput" id="data" label-selected="Data Selecionada" label-help v-model="dadosAcidente.dataAcidente" label-no-date-selected="Selecione..." locale="pt-br" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                	</b-col>
                	<b-col sm="12" md="2" class="d-flex flex-column justify-content-between">
                    	<label for="horario">Horário:</label>
                    	<b-form-timepicker :disabled="podeDesabilitarInput" id="horario" label-close-button="Fechar" v-model="dadosAcidente.horaAcidente" locale="pt-br" label-no-time-selected="00:00"></b-form-timepicker>
                	</b-col>
					<b-col sm="12" md="4" class="d-flex flex-column justify-content-between">
						<label for="localAcidente">Local do Acidente:</label>
						<b-input id="localAcidente" :disabled="podeDesabilitarInput" v-model="dadosAcidente.localAcidente" placeholder="Local"/>
					</b-col>
					<b-col sm="12" md="4" class="d-flex align-items-end justify-content-center gap-sm">
						<b-input v-model="dadosAcidente.qtdHorasTrabalhadas" type="number" min="0" :disabled="podeDesabilitarInput" id="horasTrabalhadas" class="w-25"/>
						<span for="horasTrabalhadas">Horas Trabalhadas anteriores ao acidente</span>
					</b-col>
            	</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12">
						<label for="descricaoAcidente">Descrição do Acidente:</label>
						<b-form-textarea
      					id="descricaoAcidente"
      					v-model="dadosAcidente.descricaoAcidente"
      					placeholder="Descrição do Acidente"
      					rows="6"
						:disabled="podeDesabilitarInput"
    					></b-form-textarea>
					</b-col>
				</b-form-row>
            </div>
			<div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Local do Acidente</h4>
				<b-form-row>
					<b-col md="6" sm="12">
						<label for="ruaAcidente">Rua:</label>
						<b-input id="ruaAcidente" v-model="dadosAcidente.rua" placeholder="Rua" :disabled="podeDesabilitarInput"/>
					</b-col>
					<b-col md="3" sm="12">
						<label for="numeroAcidente">Número:</label>
						<b-input id="numeroAcidente" type="number" v-model="dadosAcidente.numero" placeholder="Número" :disabled="podeDesabilitarInput"/>
					</b-col>
					<b-col md="3" sm="12">
						<label for="cepAcidente">CEP:</label>
						<b-input id="cepAcidente" v-model="dadosAcidente.cep" v-mask="'#####-###'" placeholder="CEP" :disabled="podeDesabilitarInput"/>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="3" sm="12">
						<label for="bairroAcidente">Bairro:</label>
						<b-input id="bairroAcidente" v-model="dadosAcidente.bairro" placeholder="Bairro" :disabled="podeDesabilitarInput"/>
					</b-col>
					<b-col md="3" sm="12">
						<label for="complementoAcidente">Complemento:</label>
						<b-input id="complementoAcidente" v-model="dadosAcidente.complemento" placeholder="Complemento" :disabled="podeDesabilitarInput"/>
					</b-col>
                    <b-col md="3" sm="12" class="d-flex flex-column">
                        <label for="cidadeAcidente">Cidade:</label>
                        <autoCompleteCidade ref="autoCompleteCidadeAcidente" :value="dadosAcidente.cidade" @cidadeSelecionada="selecionaCidadeAcidente($event)" :disabled="podeDesabilitarInput"/>
                    </b-col>
                    <b-col md="3" sm="12" class="d-flex flex-column">
                        <label for="estado">Estado:</label>
                        <selectEstados ref="selectEstadoAcidente" :value="dadosAcidente.estado" @estadoSelecionado="selecionaEstadoAcidente($event)" :disabled="podeDesabilitarInput"/>
                    </b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12">
						<label for="descricaoDoLocal">Descrição do Local:</label>
						<b-form-textarea
      					id="descricaoDoLocal"
      					v-model="dadosAcidente.descricaoDoLocal"
      					placeholder="Descrição do Local"
      					rows="6"
						:disabled="podeDesabilitarInput"
    					></b-form-textarea>
					</b-col>
				</b-form-row>
			</div>
			<div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Documentos Complementares</h4>
				<b-form-row>
					<b-col md="6" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="houveRegistroPolicial">Houve Registro Policial ?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="documentosComplementares.houveRegistroPolicial" name="houveRegistroPolicial" :value="false" @input="limpaDocumentosComplementares()">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="documentosComplementares.houveRegistroPolicial" name="houveRegistroPolicial" :value="true">Sim</b-form-radio>
						</div>
					</b-col>
					<b-col md="6" sm="12">
    					<b-form-file v-model="documentosComplementares.arquivo" ref="documentoComplementar" id="documentoComplementar" browse-text="Procurar" :placeholder="documentosComplementares.houveRegistroPolicial && podeDesabilitarInput? documentosComplementares.nomeDocumentoRegistroPolicial: 'Selecione um arquivo'" :disabled="!documentosComplementares.houveRegistroPolicial || podeDesabilitarInput"></b-form-file>
					</b-col>
				</b-form-row>
			</div>
			<div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Atestado Médico de Saúde</h4>
				<b-form-row>
					<b-col sm="12" md="2" class="d-flex flex-column justify-content-between">
                    	<label for="dataAtestado">Data:</label>
                    	<b-form-datepicker :disabled="podeDesabilitarInput"  id="dataAtestado" label-selected="Data Selecionada" label-help v-model="dadosAtestadoMedico.dataAtestado" label-no-date-selected="Selecione..." locale="pt-br" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                	</b-col>
                	<b-col sm="12" md="2" class="d-flex flex-column justify-content-between">
                    	<label for="horarioAtestado">Horário:</label>
                    	<b-form-timepicker :disabled="podeDesabilitarInput" id="horarioAtestado" label-close-button="Fechar" v-model="dadosAtestadoMedico.horaAtestado" locale="pt-br" label-no-time-selected="00:00"></b-form-timepicker>
                	</b-col>
					<b-col md="4" sm="12">
						<label for="localAtendimento">Local do Atendimento:</label>
						<b-input :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.localAtendimento" id="localAtendimento" placeholder="Local do Atendimento"/>
					</b-col>
					<b-col md="4" sm="12">
						<label for="cid">Doença - CID:</label>
						<b-input :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.cid" id="cid" placeholder="CID"/>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="houveInternacao">Houve Internação ?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.houveInternacao" name="houveInternacao" :value="false">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.houveInternacao" name="houveInternacao" :value="true">Sim</b-form-radio>
						</div>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12">
						<label for="diagnosticoProvavel">Diagnóstico Provável:</label>
						<b-form-textarea
      					id="diagnosticoProvavel"
      					v-model="dadosAtestadoMedico.diagnostico"
      					placeholder="Diagnóstico Provável"
      					rows="6"
						:disabled="podeDesabilitarInput"
    					></b-form-textarea>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="8" sm="12">
						<label for="medico">Médico:</label>
						<b-input id="medico" v-model="dadosAtestadoMedico.medico" placeholder="Médico" :disabled="podeDesabilitarInput"/>
					</b-col>
					<b-col md="4" sm="12">
						<label for="crm">CRM:</label>
						<b-input id="crm" v-model="dadosAtestadoMedico.crm" placeholder="CRM" :disabled="podeDesabilitarInput"/>
					</b-col>
				</b-form-row>
				<b-form-row class="my-3">
					<!-- <b-col md="6" sm="12" class="d-flex justify-content-start align-items-center gap-sm">
						<label for="possuiAtestado">Possui Atestado Médico ?:</label>
						<div class="d-flex gap-sm">
							<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.possuiAtestado" name="possuiAtestado" :value="false" @input="limpaAnexoDadosAtestadoMedico()">Não</b-form-radio>
   					  		<b-form-radio :disabled="podeDesabilitarInput" v-model="dadosAtestadoMedico.possuiAtestado" name="possuiAtestado" :value="true">Sim</b-form-radio>
						</div>
					</b-col> -->
					<b-col md="6" sm="12">
						<label>Atestado Médico:</label>
    					<b-form-file v-model="dadosAtestadoMedico.atestado" ref="atestado" id="atestado" browse-text="Procurar" :placeholder="podeDesabilitarInput ? dadosAtestadoMedico.nomeDocumentoAtestado : 'Selecione um arquivo'" :disabled="podeDesabilitarInput"></b-form-file>
					</b-col>
				</b-form-row>
				<b-form-row>
					<b-col md="12" sm="12">
						<label for="obsAtestado">Observações:</label>
						<b-form-textarea
      					id="obsAtestado"
      					v-model="dadosAtestadoMedico.observacao"
      					placeholder="Observações"
      					rows="6"
						:disabled="podeDesabilitarInput"
    					></b-form-textarea>
					</b-col>
				</b-form-row>
			</div>
			<div class="d-flex flex-column gap-sm border-bottom pb-3">
                <h4 class="grey">Dados do Solicitante</h4>
				<b-form-row>
					<b-col md="8" sm="12">
						<label for="solicitante">Solicitante:</label>
						<b-input id="solicitante" v-model="dadosSolicitante.solicitante" placeholder="Solicitante" :disabled="podeDesabilitarInput"/>
					</b-col>
					<b-col md="4" sm="12">
						<label for="cpf">CPF:</label>
						<b-input id="cpf" v-model="dadosSolicitante.cpf" v-mask="'###.###.###-##'" placeholder="Ex: 000.000.000-00" :disabled="podeDesabilitarInput"/>
					</b-col>
				</b-form-row>
			</div>
			<b-modal size="md" :id="'modal-sucesso-cat'" hide-footer centered title="Sucesso" class="d-flex flex-column">
				<h4 class="text-center">O CAT foi enviado com sucesso !</h4>
				<div class="d-flex w-100 justify-content-between mt-5">
					<b-button @click.prevent="handleCatEnviadoComSucesso()" variant="success" class="mx-auto">
						OK
					</b-button>
				</div>
			</b-modal>
			<div class="d-flex justify-content-end" v-if="!podeDesabilitarInput">
                    <b-button variant="outline-success" size="lg" class="mt-3" :disabled="carregandoSalvarCat" @click="salvaNovoCat()">
						<b-spinner v-show="carregandoSalvarCat" variant="success" class="mx-auto"></b-spinner>
						<span v-show="!carregandoSalvarCat">
							Enviar
						</span>
					</b-button>
            </div>
    </b-form>
		</div>

	</div>
</template>

<script>
import Banner from "../shared/Banner.vue";
import NavBar from "../shared/NavBar.vue";
import SelectEstados from "../shared/SelectEstados.vue";
import AutoCompleteCidade from "../shared/AutoCompleteCidade.vue";
import CatService from "../../service/CatService.js";

export default{
	name: "Cat",
	props: [ "idCat" ],
	components: {
		banner: Banner,
		navBar: NavBar,
		selectEstados: SelectEstados,
		autoCompleteCidade: AutoCompleteCidade,
	},
	data() {
		return {
			carregandoSalvarCat: false,
			carregandoBuscarCat: false,
			deuErroBuscarCat: false,

			usuarioResponsavel: JSON.parse(localStorage.getItem("usuario")),
			dadosEmpresa: {
				razaoSocial: "",
				cnpj: "",
				nomeFantasia: "",
				cidade: "",
				estado: "",
			},

			dadosFuncionario: {
				funcionario: "",
				cpf: "",
				cargo: "",
				cbo: "",
				estadoCivil: "",
				dataAdmissao: "",
				qtdAcidentesAnteriores: 0,
				remedioControlado: false,
				remedio: "",
			},

			dadosAcidente: {
				houveMorte: false,
				houveAfastamento: false,
				qtdDiasAfastamento: 0,
				tipoAcidente: "",
				lesao: "",
				parteAtingida: "",
				ladoAtingido: "",
				causa: "",
				dataAcidente: "",
				horaAcidente: "",
				localAcidente: "",
				qtdHorasTrabalhadas: 0,
				descricaoAcidente: "",
				rua: "",
				numero: "",
				cep: "",
				bairro: "",
				complemento: "",
				cidade: "",
				estado: "",
				descricaoDoLocal: "",
			},

			dadosAtestadoMedico: {
				dataAtestado: "",
				horaAtestado: "",
				localAtendimento: "",
				cid: "",
				houveInternacao: false,
				diagnostico: "",
				medico: "",
				crm: "",
				possuiAtestado: false,
				atestado: null,
				observacao: "",

				nomeDocumentoAtestado: "",
				idDocumentoAtestado: 0,
			},

			documentosComplementares: {
				id: 0,
				nomeDocumentoRegistroPolicial: "",
				arquivo: null,
				houveRegistroPolicial: false,
			},
			dadosSolicitante: {
				solicitante: "",
				cpf: "",
			},
		};
	},
	created() {
		this.consultaCatPorId();
	},
	computed: {
		podeDesabilitarInput() {
			return this.idCat != null && this.idCat != 0;
		},
	},
	methods: {
		handleCatEnviadoComSucesso() {
			this.$emit("sucesso");
		},
		consultaCatPorId() {
			if (!this.idCat) {
				return;
			}
			if (this.idCat == 0) {
				return;
			}
			this.carregandoBuscarCat = true;
			CatService.consultaPorId(this.idCat)
				.then((res) => {
					this.recuperaDadosEmpresa(res.data.dadosEmpresa);
					this.recuperaDadosFuncionario(res.data.dadosFuncionario);
					this.recuperaDadosAcidente(res.data.dadosAcidente);
					this.recuperaDadosAtestado(res.data.dadosAtestado);
					this.recuperaDocumentosComplementares(res.data);
					this.recuperaDadosSolicitante(res.data.dadosSolicitante);
				})
				.catch((err) => {
					console.log(err);
					this.deuErroBuscarCat = true;
					this.mensagem("Não foi possível recuperar os dados do CAT nesse momento", "Erro", "danger");
				})
				.finally(() => {
					this.carregandoBuscarCat = false;
				});
		},
		salvaNovoCat() {
			this.carregandoSalvarCat = true;
			const formCat = this.montaRequestNovoCat();
			const form = this.montaRequestArquivos();
			form.append("formularioCat", JSON.stringify(formCat));
			CatService.salvar(this.usuarioResponsavel.id, form)
				.then(() => {
					this.$bvModal.show("modal-sucesso-cat");
				})
				.catch((err) => {
					if (err.response) {
			 		this.mensagem(err.response.data, "Aviso", "warning");
			 	} else {
			 		this.mensagem("Não foi possível enviar o formulário de cat nesse momento, por favor tente mais tarde", "Aviso", "warning");
			 	}
				})
				.finally(() => {
					this.carregandoSalvarCat = false;
				});
		},
		montaRequestArquivos() {
			const form = new FormData();

			if (this.documentosComplementares.houveRegistroPolicial) {
				form.append("registroPolicial", this.documentosComplementares.arquivo);
			}

			if (this.dadosAtestadoMedico.atestado != null) {
				form.append("atestadoMedico", this.dadosAtestadoMedico.atestado);
			}

			return form;
		},
		montaRequestNovoCat() {
			const request = {
				dadosEmpresa: {
					razaoSocial: this.dadosEmpresa.razaoSocial,
					nomeFantasia: this.dadosEmpresa.nomeFantasia,
					cnpj: this.$options.filters.removeMascara(this.dadosEmpresa.cnpj),
					cidade: this.dadosEmpresa.cidade,
					estado: this.dadosEmpresa.estado,
				},
				dadosFuncionario: {
					funcionario: this.dadosFuncionario.funcionario,
					cpf: this.$options.filters.removeMascara(this.dadosFuncionario.cpf),
					cargo: this.dadosFuncionario.cargo,
					cbo: this.$options.filters.removeMascara(this.dadosFuncionario.cbo),
					estadoCivil: this.dadosFuncionario.estadoCivil,
					dataAdmissao: this.dadosFuncionario.dataAdmissao ? this.$options.filters.moment(this.dadosFuncionario.dataAdmissao).format("DD-MM-YYYY") : "",
					qtdAcidentesAnteriores: this.dadosFuncionario.qtdAcidentesAnteriores,
					remedioControlado: this.dadosFuncionario.remedioControlado,
					remedio: this.dadosFuncionario.remedio,
				},
				dadosAcidente: {
					houveMorte: this.dadosAcidente.houveMorte,
					houveAfastamento: this.dadosAcidente.houveAfastamento,
					qtdDiasAfastamento: this.dadosAcidente.qtdDiasAfastamento,
					tipoAcidente: this.dadosAcidente.tipoAcidente,
					lesao: this.dadosAcidente.lesao,
					parteAtingida: this.dadosAcidente.parteAtingida,
					ladoAtingido: this.dadosAcidente.ladoAtingido,
					causa: this.dadosAcidente.causa,
					dataAcidente: this.dadosAcidente.dataAcidente ? this.$options.filters.moment(this.dadosAcidente.dataAcidente).format("DD-MM-YYYY") : "",
					horaAcidente: this.dadosAcidente.horaAcidente,
					localAcidente: this.dadosAcidente.localAcidente,
					qtdHorasTrabalhadasAnterioresAoAcidente: this.dadosAcidente.qtdHorasTrabalhadas,
					descricaoAcidente: this.dadosAcidente.descricaoAcidente,
					rua: this.dadosAcidente.rua,
					numero: this.dadosAcidente.numero,
					cep: this.$options.filters.removeMascara(this.dadosAcidente.cep),
					bairro: this.dadosAcidente.bairro,
					complemento: this.dadosAcidente.complemento,
					cidade: this.dadosAcidente.cidade,
					estado: this.dadosAcidente.estado,
					descricaoLocal: this.dadosAcidente.descricaoDoLocal,
				},
				dadosAtestado: {
					dataAtestado: this.dadosAtestadoMedico.dataAtestado ? this.$options.filters.moment(this.dadosAtestadoMedico.dataAtestado).format("DD-MM-YYYY") : "",
					horaAtestado: this.dadosAtestadoMedico.horaAtestado,
					localAtendimento: this.dadosAtestadoMedico.localAtendimento,
					cid: this.dadosAtestadoMedico.cid,
					houveInternacao: this.dadosAtestadoMedico.houveInternacao,
					diagnostico: this.dadosAtestadoMedico.diagnostico,
					medico: this.dadosAtestadoMedico.medico,
					crm: this.dadosAtestadoMedico.crm,
					observacao: this.dadosAtestadoMedico.observacao,
				},
				dadosSolicitante: {
					solicitante: this.dadosSolicitante.solicitante,
					cpf: this.$options.filters.removeMascara(this.dadosSolicitante.cpf),
				},
			};
			return request;
		},
		recuperaDadosEmpresa(dadosEmpresa) {
			this.dadosEmpresa.razaoSocial = dadosEmpresa.razaoSocial;
			this.dadosEmpresa.nomeFantasia = dadosEmpresa.nomeFantasia;
			this.dadosEmpresa.cnpj = this.$options.filters.addMascara(dadosEmpresa.cnpj, "cnpj");
			this.dadosEmpresa.estado = dadosEmpresa.estado;
			this.dadosEmpresa.cidade = dadosEmpresa.cidade;
			this.$refs.autoCompleteCidadeEmpresa.query = dadosEmpresa.cidade;
			this.$refs.selectEstadoEmpresa.estadoSelecionado = dadosEmpresa.estado;
		},
		recuperaDadosFuncionario(dadosFuncionario) {
			this.dadosFuncionario.funcionario = dadosFuncionario.funcionario;
			this.dadosFuncionario.cpf = this.$options.filters.addMascara(dadosFuncionario.cpf, "cpf");
			this.dadosFuncionario.dataAdmissao = new Date(dadosFuncionario.dataAdmissao);
			this.dadosFuncionario.estadoCivil = dadosFuncionario.estadoCivil;
			this.dadosFuncionario.cargo = dadosFuncionario.cargo;
			this.dadosFuncionario.cbo = this.$options.filters.addMascara(dadosFuncionario.cbo, "cbo");
			this.dadosFuncionario.qtdAcidentesAnteriores = dadosFuncionario.qtdAcidentesAnteriores;
			this.dadosFuncionario.remedioControlado = dadosFuncionario.remedioControlado;
			this.dadosFuncionario.remedio = dadosFuncionario.remedio;
		},
		recuperaDadosAcidente(dadosAcidente) {
			this.dadosAcidente.houveMorte = dadosAcidente.houveMorte;
			this.dadosAcidente.qtdDiasAfastamento = dadosAcidente.qtdDiasAfastamento;
			this.dadosAcidente.tipoAcidente = dadosAcidente.tipoAcidente;
			this.dadosAcidente.lesao = dadosAcidente.lesao;
			this.dadosAcidente.parteAtingida = dadosAcidente.parteAtingida;
			this.dadosAcidente.ladoAtingido = dadosAcidente.ladoAtingido;
			this.dadosAcidente.causa = dadosAcidente.causa;
			this.dadosAcidente.dataAcidente = new Date(dadosAcidente.dataAcidente);
			this.dadosAcidente.horaAcidente = this.$options.filters.moment(dadosAcidente.dataAcidente).format("HH:mm");
			this.dadosAcidente.localAcidente = dadosAcidente.localAcidente;
			this.dadosAcidente.qtdHorasTrabalhadas = dadosAcidente.qtdHorasTrabalhadasAnterioresAoAcidente;
			this.dadosAcidente.descricaoAcidente = dadosAcidente.descricaoAcidente;
			this.dadosAcidente.rua = dadosAcidente.rua;
			this.dadosAcidente.numero = dadosAcidente.numero;
			this.dadosAcidente.cep = this.$options.filters.addMascara(dadosAcidente.cep, "cep");
			this.dadosAcidente.bairro = dadosAcidente.bairro;
			this.dadosAcidente.complemento = dadosAcidente.complemento;
			this.dadosAcidente.cidade = dadosAcidente.cidade;
			this.dadosAcidente.estado = dadosAcidente.estado;
			this.dadosAcidente.descricaoDoLocal = dadosAcidente.descricaoLocal;
			this.dadosAcidente.estado = dadosAcidente.estado;
			this.dadosAcidente.cidade = dadosAcidente.cidade;
			this.$refs.autoCompleteCidadeAcidente.query = dadosAcidente.cidade;
			this.$refs.selectEstadoAcidente.estadoSelecionado = dadosAcidente.estado;
		},
		recuperaDadosAtestado(dadosAtestado) {
			this.dadosAtestadoMedico.idDocumentoAtestado = dadosAtestado.idDocumentoAtestado;
			this.dadosAtestadoMedico.nomeDocumentoAtestado = dadosAtestado.nomeDocumentoAtestado;

			this.dadosAtestadoMedico.dataAtestado = new Date(dadosAtestado.dataAtestado);
			this.dadosAtestadoMedico.horaAtestado = this.$options.filters.moment(dadosAtestado.dataAtestado).format("HH:mm");
			this.dadosAtestadoMedico.localAtendimento = dadosAtestado.localAtendimento;
			this.dadosAtestadoMedico.cid = dadosAtestado.cid;
			this.dadosAtestadoMedico.houveInternacao = dadosAtestado.houveInternacao;
			this.dadosAtestadoMedico.diagnostico = dadosAtestado.diagnostico;
			this.dadosAtestadoMedico.medico = dadosAtestado.medico;
			this.dadosAtestadoMedico.crm = dadosAtestado.crm;
			this.dadosAtestadoMedico.possuiAtestado = dadosAtestado.possuiAtestado;
			this.dadosAtestadoMedico.atestado = null;
			this.dadosAtestadoMedico.observacao = dadosAtestado.observacao;
		},
		recuperaDocumentosComplementares(documentos) {
			this.documentosComplementares.houveRegistroPolicial = documentos.houveRegistroPolicial;
			this.documentosComplementares.id = documentos.idDocumentoRegistroPolicial;
			this.documentosComplementares.nomeDocumentoRegistroPolicial = documentos.nomeDocumentoRegistroPolicial;
		},
		recuperaDadosSolicitante(dadosSolicitante) {
			this.dadosSolicitante.solicitante = dadosSolicitante.solicitante;
			this.dadosSolicitante.cpf = this.$options.filters.addMascara(dadosSolicitante.cpf, "cpf");
		},
		selecionaCidadeEmpresa(event) {
			this.dadosEmpresa.cidade = event;
		},
		selecionaEstadoEmpresa(event) {
			this.dadosEmpresa.estado = event;
		},
		selecionaCidadeAcidente(event) {
			this.dadosAcidente.cidade = event;
		},
		selecionaEstadoAcidente(event) {
			this.dadosAcidente.estado = event;
		},
		limpaCampoNomeRemedio() {
			if (!this.podeDesabilitarInput) {
				this.dadosFuncionario.remedio = "";
			}
		},
		limpaCampoQtdDiasAfastamento() {
			this.dadosAcidente.qtdDiasAfastamento = 0;
		},
		limpaDocumentosComplementares() {
			this.documentosComplementares.arquivo = null;
			this.$refs.documentoComplementar.reset();
		},
		limpaAnexoDadosAtestadoMedico() {
			this.dadosAtestadoMedico.atestado = null;
			this.$refs.atestado.reset();
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>
<style scoped>
.grey{
    color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/Cat/FormularioCat.vue